import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as events from '../../../events';
import * as actions from '../../../state';

import styles from './styles.module.css';

function GoogleSso() {
  const dispatch = useDispatch();

  const googleSsoClientId = useSelector((state) => actions.selectConfig(state, 'PORTAL_LOGIN_GOOGLE_SSO_CLIENT_ID'));
  // eslint-disable-next-line max-len
  const googleSsoClientIdByHost = useSelector((state) => actions.selectConfig(state, `PORTAL_LOGIN_GOOGLE_SSO_CLIENT_ID_${window.location.hostname}`));

  useEffect(() => {
    const aScript = document.createElement('script');
    aScript.type = 'text/javascript';
    aScript.src = 'https://accounts.google.com/gsi/client';
    document.head.appendChild(aScript);

    aScript.onload = () => {
      const clientId = googleSsoClientIdByHost || googleSsoClientId;

      window?.google?.accounts?.id?.initialize({
        client_id: clientId,
        callback: (res) => {
          if (res?.credential) {
            dispatch(events.ssoLoginUser(res.credential, 'google'));
          }
        },
      });

      let locale = localStorage.getItem('chartsRenderedLang');
      if (!locale || locale === 'tbd') {
        locale = 'en_US';
      }

      window?.google?.accounts?.id?.renderButton(
        document.getElementById('google-sso'),
        {
          theme: 'outline',
          size: 'large',
          shape: 'rectangle',
          width: 316,
          logo_alignment: 'left',
          locale,
        },
      );
    };
  }, []);

  return (
    <div
      id="google-sso"
      className={styles.ssoContainer}
      style={{ paddingTop: 24, height: 44, overflow: 'hidden' }}
    />
  );
}

export default GoogleSso;
